export const APPROVAL_STATUS_OPTIONS = [
  { value: 'missing', label: 'Fehlt', color: 'error' },
  { value: 'requested', label: 'Beantragt', color: 'warning' },
  { value: 'approved', label: 'Genehmigt', color: 'success' },
  { value: 'rejected', label: 'Abgelehnt', color: 'error' },
  { value: 'expired', label: 'Abgelaufen', color: 'default' },
  { value: 'not_required', label: 'Nicht erforderlich', color: 'info' }
];

export const PERSON_GROUP_STATUS_OPTIONS = [
  { value: 'unknown', label: 'Nicht geprüft', color: 'default' },
  { value: 'eligible', label: 'Erfüllt', color: 'success' },
  { value: 'needs_review', label: 'Manuell prüfen', color: 'warning' },
  { value: 'not_eligible', label: 'Nicht erfüllt', color: 'error' }
];

export const MOBILITY_MARK_OPTIONS = [
  { value: 'aG', label: 'Merkzeichen aG' },
  { value: 'Bl', label: 'Merkzeichen Bl' },
  { value: 'H', label: 'Merkzeichen H' }
];

export const CARE_LEVEL_OPTIONS = [
  { value: '', label: 'Nicht hinterlegt' },
  { value: '1', label: 'Pflegegrad 1' },
  { value: '2', label: 'Pflegegrad 2' },
  { value: '3', label: 'Pflegegrad 3' },
  { value: '4', label: 'Pflegegrad 4' },
  { value: '5', label: 'Pflegegrad 5' }
];

export const ELIGIBILITY_PROOF_TYPE_OPTIONS = [
  { value: '', label: 'Nicht hinterlegt' },
  { value: 'customer_master', label: 'Kundenstamm' },
  { value: 'severe_disability_card', label: 'Schwerbehindertenausweis' },
  { value: 'care_level_notice', label: 'Pflegegradbescheid' },
  { value: 'health_insurance_approval', label: 'Krankenkassen-Genehmigung' },
  { value: 'driver_proof_scan', label: 'Fahrer-Nachweis-Scan' },
  { value: 'manual_review', label: 'Manuell geprüft' },
  { value: 'other', label: 'Sonstiger Nachweis' }
];

export const DOCUMENT_STATUS_OPTIONS = [
  { value: 'incomplete', label: 'Unvollständig', color: 'warning' },
  { value: 'complete', label: 'Vollständig', color: 'success' },
  { value: 'expired', label: 'Abgelaufen', color: 'error' }
];

export const BILLING_STATUS_OPTIONS = [
  { value: 'not_ready', label: 'Nicht bereit', color: 'default' },
  { value: 'ready', label: 'Bereit', color: 'success' },
  { value: 'exported', label: 'Exportiert', color: 'info' },
  { value: 'submitted', label: 'Eingereicht', color: 'primary' },
  { value: 'paid', label: 'Bezahlt', color: 'success' },
  { value: 'rejected', label: 'Beanstandet', color: 'error' }
];

export const TREATMENT_TYPE_OPTIONS = [
  { value: 'dialysis', label: 'Dialyse' },
  { value: 'chemo', label: 'Chemo' },
  { value: 'radiation', label: 'Bestrahlung' },
  { value: 'rehab', label: 'Reha' },
  { value: 'therapy', label: 'Therapie' },
  { value: 'doctor', label: 'Arzttermin' },
  { value: 'other', label: 'Sonstiges' }
];

export const ROUTE_SCOPE_OPTIONS = [
  { value: 'fixed_route', label: 'Feste Strecke' },
  { value: 'facility_only', label: 'Feste Einrichtung' },
  { value: 'flexible', label: 'Flexibel' }
];

export const COPAYMENT_STATUS_OPTIONS = [
  { value: 'unknown', label: 'Unbekannt' },
  { value: 'exempt', label: 'Befreit' },
  { value: 'required', label: 'Zuzahlung erforderlich' },
  { value: 'collected_elsewhere', label: 'Anderweitig geklärt' }
];

export const getOption = (options, value) =>
  options.find(option => option.value === value) || options[0];

export const toDateInputValue = (value) => {
  if (!value) return '';
  const date = value.toDate
    ? value.toDate()
    : value.seconds
      ? new Date(value.seconds * 1000)
      : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toISOString().slice(0, 10);
};

export const formatDate = (value) => {
  if (!value) return 'Nicht gesetzt';
  const date = value.toDate
    ? value.toDate()
    : value.seconds
      ? new Date(value.seconds * 1000)
      : new Date(value);
  if (Number.isNaN(date.getTime())) return 'Nicht gesetzt';
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);
};
